import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { isFunction } from '@fi-shared/utils/is-function';

@Component({
    selector: 'fi-section-select',
    templateUrl: './section-select.component.html',
    styleUrls: ['./section-select.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class SectionSelectComponent implements OnInit {
    @Input() selectedKey;
    @Input() sectionsList;
    @Input() selectCheckFunction;
    @Output() selectedKeyChange: EventEmitter<string> = new EventEmitter<string>();

    constructor() {}

    selectSection(section) {
        if (this.isSectionDisabled(section)) {
            return false;
        }

        if (this.selectCheckFunction(section.key) !== false) {
            this.selectedKey = section.key;
            this.selectedKeyChange.emit(this.selectedKey);
        }
    }

    isSectionDisabled = function (section) {
        return section.disabled === true || (isFunction(section.disabled) && section.disabled());
    };

    ngOnInit() {}
}
